import React from 'react'
import {
  CustomDropdown,
  InputNumeroDecimal,
  InputText,
  SectionTitle,
} from '../../../../../components'
import { CTE_TIPOS_MEDIDA, CTE_UNIDADES_CARGA } from '../../../../../constants/cte-sem-nota'

export default function SecaoCarga({ carga, onChange, onUnidadeChange, dica = null }) {
  return (
    <>
      <div className="p-col-12">
        <SectionTitle title="Carga" />
        {dica && <span style={{ color: 'gray', fontSize: 12 }}>{dica}</span>}
      </div>
      <div className="p-md-3 p-col-12">
        <InputNumeroDecimal
          label="Valor da Carga:*"
          marginTop={10}
          placeholder="Ex.: 125.000,00"
          value={carga.valor_carga}
          onChange={value => onChange({ ...carga, valor_carga: value })}
        />
      </div>
      <div className="p-md-5 p-col-12">
        <InputText
          label="Produto Predominante:*"
          marginTop={10}
          value={carga.produto_predominante}
          maxLength={60}
          placeholder="Ex.: PRODUTOS LACTEOS, ALIMENTOS REFRIGERADOS, BEBIDAS"
          onChange={value => onChange({ ...carga, produto_predominante: value })}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <CustomDropdown
          optionLabel="label"
          options={CTE_UNIDADES_CARGA}
          value={carga.unidade}
          label="Unidade de medida:*"
          onChange={onUnidadeChange}
        />
      </div>
      <div className="p-md-3 p-col-12">
        <InputNumeroDecimal
          label="Quantidade:*"
          marginTop={10}
          decimalScale={4}
          placeholder="Ex.: 18.500,50"
          value={carga.quantidade}
          onChange={value => onChange({ ...carga, quantidade: value })}
        />
      </div>
      <div className="p-md-5 p-col-12">
        <CustomDropdown
          optionLabel="label"
          options={CTE_TIPOS_MEDIDA}
          value={CTE_TIPOS_MEDIDA.find(tipo => tipo.value === carga.tipo_medida) || null}
          label="Tipo de medida:*"
          onChange={tipo => onChange({ ...carga, tipo_medida: tipo.value })}
          tooltip="Sugerido pela unidade; exemplos do leiaute da SEFAZ"
        />
      </div>
    </>
  )
}
